import { createAsyncThunk } from "@reduxjs/toolkit";
import { COREURL } from "../../constants/api_constants";
import { ApiServices } from "../../services/api_services";

const getCustomHours = createAsyncThunk("hours/getCustomHoursList", async () => {
  return ApiServices.get(COREURL, "/get_custom_hours_list")
    .then((response) => {
      return response;
    })
    .catch((error) => error);
});
const getHoursDetails = createAsyncThunk("hours/getcustomHourById", async (id: any) => {
  return ApiServices.get(COREURL, `/get_custom_hours_detail/${id}`)
    .then((response) => response)
    .catch((error) => error);
});

const DeleteHours = createAsyncThunk("hours/DeleteHoursById", async (id: any) => {
  return ApiServices.delete(COREURL, `/delete_custom_hours/${id}`)
    .then((response) => response)
    .catch((error) => error);
});

const createBusinessHours = createAsyncThunk("hours/createHours", async (data: any) => {
  const bodyData = {};
  const body = { ...bodyData, ...data };
  return ApiServices.post(COREURL, "/insert_custom_hours", body)

    .then((response) => response)
    .catch((error) => error);
});

const updateBusinessHours = createAsyncThunk("hours/updateHours", async (data: any) => {
  const id = data?.id;
  delete data.id;
  const bodyData = {};
  const body = { ...bodyData, ...data };

  return ApiServices.put(COREURL, `/update_custom_hours/${id}`, body)
    .then((response) => response)
    .catch((error) => error);
});

export { getCustomHours, getHoursDetails, createBusinessHours, updateBusinessHours, DeleteHours };
